/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.0.1
 */

import { RefObject } from 'react';

import orderBy from 'lodash/orderBy';
import Carousel from 'react-multi-carousel';

import { IChartPieItem } from '../../../../../../components/common/Chart/ChartPie/chartPieTypes';
import ICommonTranslation from '../../../../../../modules/internationalization/types/common';
import IPageDashboardTranslation from '../../../../../../modules/internationalization/types/pages/dashboard/dashboard';
import { widgetCostsConfiguration } from '../constant/widgetCostsConstants';
import { EWidgetCostsChart, TWidgetCostsChartValue } from '../types/widgetCostsType';
import WidgetCostsChart from './WidgetCostsChart';

export interface IWidgetCostsSliderProps {
    carouselRef: RefObject<Carousel>;
    chart: TWidgetCostsChartValue;
    translation: IPageDashboardTranslation & ICommonTranslation;
}

const WidgetCostsSlider = (props: IWidgetCostsSliderProps) => {
    const configChartData = (): IChartPieItem[] =>
        orderBy(
            Object.keys(props.chart.chart)
                .map((key: string) => ({
                    color: widgetCostsConfiguration.chart.colors[key as EWidgetCostsChart],
                    item: props.translation.widgets.costs.chart[key as EWidgetCostsChart],
                    value: props.chart.chart[key as EWidgetCostsChart] || 0,
                }))
                .filter((chart) => chart.value > 0),
            ['value', 'item'],
            ['desc', 'asc'],
        );

    return (
        <Carousel
            arrows={false}
            draggable={false}
            infinite={true}
            keyBoardControl={false}
            ref={props.carouselRef}
            responsive={widgetCostsConfiguration.carousel.responsive}
            showDots={false}
        >
            <WidgetCostsChart
                configuration={widgetCostsConfiguration}
                currency={props.translation.currency}
                data={configChartData()}
                total={props.chart.totalOfBasicChargesAggregates}
            />
        </Carousel>
    );
};
export default WidgetCostsSlider;
